// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-compose-post-js": () => import("./../../../src/pages/compose/post.js" /* webpackChunkName: "component---src-pages-compose-post-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-twitter-js": () => import("./../../../src/pages/twitter.js" /* webpackChunkName: "component---src-pages-twitter-js" */)
}

